/* unplugin-vue-components disabled */import { render } from "./OnlineService.vue?vue&type=template&id=26deacf0&scoped=true"
import script from "./OnlineService.vue?vue&type=script&lang=js"
export * from "./OnlineService.vue?vue&type=script&lang=js"

import "./OnlineService.vue?vue&type=style&index=0&id=26deacf0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26deacf0"]])

export default __exports__